/*
 * "Signed in as" - who this browser is signed in as, at the foot of a sidebar.
 *
 * The admin sidebar has always carried it; since 2026-10-09 the public sidebars do
 * too (the browse page's and an article's), by the owner's request, shown only to
 * a reader who is signed in. One component for both so the two cannot disagree.
 *
 * The name is the server's verdict when there is one (identity, from
 * /api/admin/me) - the same order the admin sidebar always used - and otherwise
 * what MSAL knows of the account. "Access via ..." says how the server granted the
 * right to administer, so it appears only for an administrator: a signed-in reader
 * without that right has no verdict to describe. Both lines are in the chosen
 * language (S48, 2026-10-29) - "Logget ind som", "Adgang via gruppekrav".
 */

import { useAuth } from '../auth/AuthProvider.js';
import { useMessages } from '../i18n/language.js';

export function SignedInAs(): JSX.Element | null {
  const { signedIn, identity, account } = useAuth();
  const t = useMessages();
  if (!signedIn) return null;

  const who = identity
    ? (identity.username ?? identity.name ?? identity.objectId)
    : (account?.name ?? account?.username ?? t.account.unnamedAccount);

  return (
    <div className="sidebar-group">
      <h3>{t.account.signedInAs}</h3>
      <p className="faint" style={{ margin: 0, overflowWrap: 'anywhere' }}>
        {who}
      </p>
      {identity?.isAdmin && identity.grantedVia && (
        <p className="faint" style={{ margin: '0.25rem 0 0' }}>
          {t.account.accessVia(t.account.grantedVia[identity.grantedVia])}
        </p>
      )}
    </div>
  );
}
